export default "__VITE_ASSET__c3159ee6__"